import { Outlet } from "react-router-dom";
import { Box, Container, CssBaseline } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileBottomNavigation from "../mobile/MobileBottomNavigation";

/**
 * Main layout component for public pages with Material UI design
 * @returns {React.ReactNode}
 */
const Layout = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default'
      }}
    >
      <CssBaseline />
      <Navbar />
      <Container 
        component="main" 
        maxWidth={false} 
        disableGutters
        sx={{ 
          mt: { xs: 0, sm: 1 }, 
          mb: { xs: 2, sm: 3 }, 
          py: { xs: 0, sm: 1 },
          px: { xs: 0 }, // Remove horizontal padding completely
          pt: 0, // Ensure no top padding on all screen sizes
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Outlet />
      </Container>
      <Footer />
      <MobileBottomNavigation />
    </Box>
  );
};

export default Layout;
